var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"请选择线索来源"},on:{"input":_vm.onInput},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }